import { render, staticRenderFns } from "./SettingsChangePhoto.vue?vue&type=template&id=725c9bed&scoped=true&"
import script from "./SettingsChangePhoto.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePhoto.vue?vue&type=script&lang=js&"
import style0 from "./SettingsChangePhoto.vue?vue&type=style&index=0&id=725c9bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c9bed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725c9bed')) {
      api.createRecord('725c9bed', component.options)
    } else {
      api.reload('725c9bed', component.options)
    }
    module.hot.accept("./SettingsChangePhoto.vue?vue&type=template&id=725c9bed&scoped=true&", function () {
      api.rerender('725c9bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/SettingsChangePhoto.vue"
export default component.exports